

export enum GroupType {
Single = 0,
Accordion = 1,
}